/** @format */

import React, { useEffect, useState } from "react";
import Image from "components/Image";
import ModalClose from "assets/icons/ModalClose";
import ModalDownload from "assets/icons/ModalDownload";
import ModalShare from "assets/icons/ModalShare";
import { useAppStore } from "store/useAppStore";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface PreviewModalProps {
  downloadImage: (imageUrl: string) => void;
  shareImage: (imageUrl: string) => void;
  handleModalClose: () => void;
}

export default function PreviewModal({
  downloadImage,
  shareImage,
  handleModalClose,
}: PreviewModalProps) {
  const generatedImageHistory: string[] = useAppStore().generatedImageHistory;
  const uploadedGarmentsHistory: string[] =
    useAppStore().uploadedGarmentsHistory;
  const previewImageUrl = useAppStore().previewImageUrl;
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  console.log(
    uploadedGarmentsHistory,
    generatedImageHistory,
    "uploadedGarmentsHistory from preview modal"
  );

  useEffect(() => {
    const index = generatedImageHistory.indexOf(previewImageUrl);
    if (index !== -1) {
      setCurrentImageIndex(index);
    }
  }, [previewImageUrl, generatedImageHistory]);

  const navigateNext = () => {
    if (currentImageIndex < generatedImageHistory.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const navigatePrevious = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const currentImageUrl = generatedImageHistory[currentImageIndex];
  const currentUploadedGarmentUrl = uploadedGarmentsHistory[currentImageIndex];

  return (
    <div className="bg-gray-900 bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-lg w-full h-[100vh] top-0 fixed z-10 left-0 right-0 flex justify-between items-center px-[5rem]">
      <span
        onClick={handleModalClose}
        className="cursor-pointer bg-black rounded-full absolute top-[3rem] left-[3rem]"
      >
        <ModalClose />
      </span>
      <div className="w-full flex gap-[10rem] justify-center items-center">
        <span
          className="cursor-pointer h-fit bg-[#121212] active:bg-[#000] rounded-full p-4 flex justify-center items-center"
          onClick={navigatePrevious}
        >
          <ArrowBackIosNewIcon
            sx={{
              color: "#fff",
              fontSize: "2rem",
            }}
          />
        </span>
        <div className="flex gap-[6rem] justify-center items-center">
          <div className="flex flex-col gap-[4rem]">
            <p className="text-white text-[1.6rem] text-center">
              Uploaded Garments
            </p>
            <div className="w-[15rem] h-[15rem] rounded-xl">
              <img
                className="w-full h-full rounded-xl object-cover"
                src={currentUploadedGarmentUrl}
                alt=""
              />
            </div>
            {/* <div className="w-[15rem] h-[15rem] rounded-xl">
              <img
                className="w-full h-full rounded-xl"
                src="https://th.bing.com/th/id/OIP.dI4jGktOZkVgoFP5gLwNhgHaHa?rs=1&pid=ImgDetMain"
                alt=""
              />
            </div> */}
          </div>
          <div className="">
            <p className="text-white text-[1.6rem] mb-[4rem] text-center">
              Generated Image{" "}
            </p>
            <div className="h-[543px]">
              <img
                onLoad={() => setIsLoaded(true)}
                className={`transition-opacity duration-1000 ease-in-out ${
                  isLoaded ? "opacity-100" : "opacity-0"
                } rounded-3xl w-full h-full`}
                src={currentImageUrl}
                alt="image"
              />
            </div>
          </div>
        </div>
        <span
          className="cursor-pointer h-fit bg-[#121212] active:bg-[#000] rounded-full p-4 flex justify-center items-center"
          onClick={navigateNext}
        >
          <ArrowForwardIosIcon
            sx={{
              color: "#fff",
              fontSize: "2rem",
            }}
          />
        </span>
      </div>
      <span
        onClick={() => downloadImage(currentImageUrl)}
        className="cursor-pointer bg-black rounded-full absolute top-[3rem] right-[3rem]"
      >
        <ModalDownload />
      </span>
    </div>
  );
}
{
  /* <span className="h-[80%] self-start my-auto ">
<span
   onClick={handleModalClose}
   className="cursor-pointer bg-black">
   <ModalClose />
</span>
</span>
<div className=" h-[80%] flex items-center gap-5">
<span
   className="cursor-pointer bg-[#121212] active:bg-[#000] rounded-full p-4 flex justify-center items-center"
   onClick={navigatePrevious}>
   <ArrowBackIosNewIcon
      sx={{
         color: "#fff",
         fontSize: "2rem",
      }}
   />
</span>
<div className="flex w-[50%]">
   <div className="flex flex-col justify-between">
      <p className="text-white text-[1.6rem]">Uploaded Garments</p>
      <div className="w-[15rem] h-[15rem] rounded-xl">
         <img
            className="w-full h-full rounded-xl"
            src="https://th.bing.com/th/id/R.6c3ddd4f609acc5e3fff3e13255cfc15?rik=nMtuon3w6BIpiw&riu=http%3a%2f%2finikweb.com%2fwp-content%2fuploads%2f2015%2f02%2ft473kellygreen.jpg&ehk=ngEG5J4NY4mngHySwtGScfJOpm%2bFsWS9P0TPNj15Qww%3d&risl=&pid=ImgRaw&r=0"
            alt=""
         />
      </div>
      <div className="w-[15rem] h-[15rem] rounded-xl">
         <img
            className="w-full h-full rounded-xl"
            src="https://th.bing.com/th/id/OIP.dI4jGktOZkVgoFP5gLwNhgHaHa?rs=1&pid=ImgDetMain"
            alt=""
         />
      </div>
   </div>
   <img
      onLoad={() => setIsLoaded(true)}
      className={`transition-opacity duration-1000 ease-in-out ${isLoaded ? "opacity-100" : "opacity-0"} rounded-xl w-full h-full`}
      src={currentImageUrl}
      alt="image"
   />
</div>
<span
   className="cursor-pointer bg-[#121212] active:bg-[#000] rounded-full p-4 flex justify-center items-center"
   onClick={navigateNext}>
   <ArrowForwardIosIcon
      sx={{
         color: "#fff",
         fontSize: "2rem",
      }}
   />
</span>
</div>
<div className="flex flex-col gap-7 self-start h-[80%] my-auto">
<span
   onClick={() => downloadImage(currentImageUrl)}
   className="cursor-pointer">
   <ModalDownload />
</span>
<span
   onClick={() => shareImage(currentImageUrl)}
   className="cursor-pointer">
   <ModalShare />
</span>
</div> */
}
